import { RouteErrorFallback } from '@components/errors/RouteErrorFallback'
import { studentActionPlansQueryOptions } from '@features/action-plans/queries'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans')({
    component: Outlet,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(studentActionPlansQueryOptions(params.studentNo))
        return null
    },
    staticData: {
        crumb: { label: 'Action Plans' }
    },
    errorComponent: ({ error, reset }) => (
        <RouteErrorFallback
            error={error}
            onRetry={reset}
            title="An error occurred"
            description="There was an error loading the action plans."
        />
    )
})
